/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIList from 'UIComponents/list/UIList';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
export default class _class extends Component {
  render() {
    const _this$props = this.props,
          {
      children,
      className,
      errors,
      warnings
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "errors", "warnings"]);

    const errorMessages = errors.length ? /*#__PURE__*/_jsx(UIList, {
      children: errors
    }) : null;
    const warningMessages = warnings.length ? /*#__PURE__*/_jsx(UIList, {
      children: warnings
    }) : null;
    const formControlClassName = classNames('sidebar-form-control', className);
    return /*#__PURE__*/_jsx(ToolFormControl, Object.assign({
      className: formControlClassName,
      error: !!errorMessages || !!warningMessages,
      validationMessage: errorMessages || warningMessages
    }, rest, {
      children: children
    }));
  }

}
_class.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.node),
  warnings: PropTypes.arrayOf(PropTypes.node)
};
_class.defaultProps = {
  className: null,
  errors: [],
  warnings: []
};